"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListMixin = exports.UpdateMixin = exports.RetrieveMixin = exports.CreateMixin = exports.applyMixins = void 0;
const core_1 = require("../types/core");
function applyMixins(derivedCtor, constructors) {
    constructors.forEach((baseCtor) => {
        Object.getOwnPropertyNames(baseCtor.prototype).forEach((name) => {
            Object.defineProperty(derivedCtor.prototype, name, Object.getOwnPropertyDescriptor(baseCtor.prototype, name) ||
                Object.create(null));
        });
    });
}
exports.applyMixins = applyMixins;
class CreateMixin {
    constructor(axiosInstance) {
        this.endpoint = "";
        this.axiosInstance = axiosInstance;
        this.create = this._create;
    }
    async _create(data, role = core_1.PartiuRole.user, pdvId = "", agreementId = "") {
        const { data: _data } = await this.axiosInstance.post(this.endpoint, data, {
            headers: {
                "User-Role": role,
                "User-Pdv": pdvId.toString(),
                "User-Agreement": agreementId.toString(),
            },
        });
        return _data;
    }
}
exports.CreateMixin = CreateMixin;
class RetrieveMixin {
    constructor(axiosInstance) {
        this.endpoint = "";
        this.axiosInstance = axiosInstance;
        this.create = this._create;
    }
    async _create(data, role = core_1.PartiuRole.user, pdvId = "", agreementId = "") {
        const { data: _data } = await this.axiosInstance.post(this.endpoint, data, {
            headers: {
                "User-Role": role,
                "User-Pdv": pdvId.toString(),
                "User-Agreement": agreementId.toString(),
            },
        });
        return _data;
    }
}
exports.RetrieveMixin = RetrieveMixin;
class UpdateMixin {
    constructor(axiosInstance) {
        this.endpoint = "";
        this.axiosInstance = axiosInstance;
        this.update = this._update;
    }
    async _update(id, data, role = core_1.PartiuRole.user) {
        const { data: _data } = await this.axiosInstance.patch(this.endpoint + `${id}/`, data, {
            headers: {
                HTTP_USER_ROLE: role,
            },
        });
        return _data;
    }
}
exports.UpdateMixin = UpdateMixin;
class ListMixin {
    constructor(axiosInstance) {
        this.endpoint = "";
        this.axiosInstance = axiosInstance;
        this.list = this._list;
    }
    async get(url, params = new URLSearchParams(), headers = {}) {
        const { data } = await this.axiosInstance.get(url + "?" + params.toString(), {
            headers,
        });
        return data;
    }
    async _list(page = undefined, params = {}, role = core_1.PartiuRole.user, pdvId = "", agreementId = "") {
        const _params = new URLSearchParams();
        if (page)
            _params.append("page", page.toString());
        Object.entries(params).forEach(([key, value]) => {
            let _value;
            if (value == undefined)
                return console.warn("Received undefined value, this value is not sent through the API");
            try {
                _value = value.toString();
            }
            catch {
                _value = value;
            }
            _params.append(key, _value);
        });
        const data = await this.get(this.endpoint, _params, {
            "User-Role": role,
            "User-Pdv": pdvId.toString(),
            "User-Agreement": agreementId.toString(),
        });
        if ("next" in data && "previous" in data)
            return data["results"];
        return data;
    }
}
exports.ListMixin = ListMixin;
//# sourceMappingURL=mixins.js.map